import React from "react";
import PropTypes from "prop-types"
import ChangeStockForm from "./product/change-stock-form"

const Image = ({onClick, src}) => (
  <div className="shop-product__image" onClick={onClick} >
    <img src={src}/>
  </div>
)

Image.propTypes = {onClick: PropTypes.func, src: PropTypes.string}

const Title = ({onClick, text}) => (
  <div className="shop-product__title" onClick={onClick} >{text}</div>
)

Title.propTypes = {onClick: PropTypes.func, text: PropTypes.string}

const QuantityInStock = ({visible, onClick, value}) => (
  visible && <div className="shop-product__stock-value" onClick={onClick}>{value}</div>
)

QuantityInStock.propTypes = {visible: PropTypes.bool, onClick: PropTypes.func, value: PropTypes.number}

class ProductItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {changeStockMode: false, newQuantityInStock: ""};

    this.onClick = event => {
      event.preventDefault();
      this.props.onClick(this.props.productId)
    }

    this.toggleChangeQuantity = e => {
      e.preventDefault();
      if (!this.props.canChangeQuantityInStock) return;
      if (this.state.changeStockMode) {
        this.setState({changeStockMode: false})
      } else {
        this.setState({
          changeStockMode: true,
          newQuantityInStock: this.props.quantityInStock
        })
      }
    }

    this.cancelChangeQuantity = () => this.setState({changeStockMode: false, newQuantityInStock: ""});

    this.changeNewQuantity = e => {
      const newValue = parseInt(e.currentTarget.value)
      this.setState({newQuantityInStock: isNaN(newValue) ? "" : newValue});
    }

    this.confirmChangeQuantity = () => {
      this.setState({changeStockMode: false});
      if (this.state.newQuantityInStock !== "") {
        this.props.onChangeQuantityInStock(this.state.newQuantityInStock);
      }
    }
  }

  product() { return this.props.products[this.props.productId] }

  render() {
    const product = this.product();
    const {
      props: {canChangeQuantityInStock, isSortable, showQuantityInStock},
      state: {changeStockMode, newQuantityInStock},
      cancelChangeQuantity, changeNewQuantity, confirmChangeQuantity, onClick, toggleChangeQuantity
    } = this
    const actualOnClick = canChangeQuantityInStock && !product.childItemIds ? toggleChangeQuantity : onClick
    let visibleQuantityInStock
    if (changeStockMode && newQuantityInStock !== "") {
      visibleQuantityInStock = newQuantityInStock
    } else if (canChangeQuantityInStock) {
      visibleQuantityInStock = this.props.quantityInStock
    } else {
      visibleQuantityInStock = this.product().quantityInStock
    }

    return (
      <div className={isSortable ? "shop-product sortable" : "shop-product"} data-id={product.id} >
        <Image onClick={actualOnClick} src={product.imageUrl} />
        <Title onClick={actualOnClick} text={product.title} />
        <QuantityInStock
          visible={!!showQuantityInStock && !product.childItemIds}
          onClick={toggleChangeQuantity}
          value={visibleQuantityInStock}
        />
        <ChangeStockForm
          visible={changeStockMode}
          value={newQuantityInStock}
          onCancel={cancelChangeQuantity}
          onChange={changeNewQuantity}
          onConfirm={confirmChangeQuantity}
        />
      </div>
    )
  }
}

ProductItem.propTypes = {
  canChangeQuantityInStock: PropTypes.bool,
  isSortable: PropTypes.bool,
  quantityInStock: PropTypes.number,
  showQuantityInStock: PropTypes.bool,
  products: PropTypes.object.isRequired,
  productId: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onChangeQuantityInStock: PropTypes.func
}

export default ProductItem
